/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ index: NonNullable<unknown>, codec: NonNullable<unknown> }} Audio_Embed_Export_Stream_DataInputs */



/**
* | output |
* | --- |
* | "Data {index}: {codec}" |
*
* @param {Audio_Embed_Export_Stream_DataInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_embed_export_stream_data = /** @type {((inputs: Audio_Embed_Export_Stream_DataInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Embed_Export_Stream_DataInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Données ${i?.index}: ${i?.codec}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Daten ${i?.index}: ${i?.codec}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Dati ${i?.index}: ${i?.codec}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Данные ${i?.index}: ${i?.codec}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Datos ${i?.index}: ${i?.codec}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`数据 ${i?.index}: ${i?.codec}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`データ ${i?.index}: ${i?.codec}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`डेटा ${i?.index}: ${i?.codec}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Dados ${i?.index}: ${i?.codec}`)
	return /** @type {LocalizedString} */ (`Data ${i?.index}: ${i?.codec}`)
});